import { authentication } from "./authentication";
import { externalPage } from "./externalPage";
import { footer } from "./footer";
import { profile } from "./profile";
import { purchaseOrder } from "./purchaseOrder";
import { sidebar } from "./sidebar";
import { personalDetails } from "./personalDetails";
import { projects } from "./projects";
import { document } from "./documents";
import { earnings } from "./earnings";
import { service } from "./service";
import { invoices } from "./invoices";
export const TranslationToEnglish = {
  ...authentication,
  ...footer,
  ...profile,
  ...externalPage,
  ...purchaseOrder,
  ...sidebar,
  ...personalDetails,
  ...projects,
  ...document,
  ...earnings,
  ...service,
  ...invoices,
};
